import React, { Component } from 'react';
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';
import './styles.scss';

class LandingPage extends Component {
    render() {
        return (
            <div className="grid-content">
                <Header />
                <Main />
                <Footer />
            </div>
        )
    }
}

export default LandingPage;